import { render, staticRenderFns } from "./ButtonFunctionalities.vue?vue&type=template&id=21c67a66&"
import script from "./ButtonFunctionalities.vue?vue&type=script&lang=js&"
export * from "./ButtonFunctionalities.vue?vue&type=script&lang=js&"
import style0 from "./ButtonFunctionalities.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21c67a66')) {
      api.createRecord('21c67a66', component.options)
    } else {
      api.reload('21c67a66', component.options)
    }
    module.hot.accept("./ButtonFunctionalities.vue?vue&type=template&id=21c67a66&", function () {
      api.rerender('21c67a66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ButtonFunctionalities.vue"
export default component.exports